import { createSelector } from 'reselect';
import { getIsErpJobDispatchEnabled } from 'lib/selectors/getIsErpJobDispatchEnabled';
import { getIsMesBehaviorMode } from 'lib/selectors/getIsMesBehaviorMode';

export const getIsErpDriven = createSelector(
  [getIsErpJobDispatchEnabled, getIsMesBehaviorMode],
  (isErpJobDispatchEnabled, isMesBehaviorMode) => {
    return isErpJobDispatchEnabled && isMesBehaviorMode;
  }
);
